import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EPatientCreditCardsSource;
(function (EPatientCreditCardsSource) {
  EPatientCreditCardsSource["Instamed"] = "instamed";
})(EPatientCreditCardsSource || (EPatientCreditCardsSource = {}));
export const fieldsPatientCreditCard = _extends({}, fieldsIBaseModel, {
  cardIssuer: {
    type: 'Text'
  },
  expiryMonth: {
    type: 'Number'
  },
  expiryYear: {
    type: 'Number'
  },
  externalId: {
    type: 'Object'
  },
  lastFourDigits: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  }
});